import {
  ILoginRequest,
  IAuthSessionRequest,
  IAuthSessionResponse,
  IAuthSession,
  IRefreshRequest,
} from '../interfaces';

export function mapLoginRequest(
  request: ILoginRequest,
  clientId?: string,
  clientSecret?: string,
): IAuthSessionRequest {
  return {
    username: request.email,
    password: request.password,
    grant_type: 'password',
    client_id: clientId || '',
    client_secret: clientSecret || '',
  };
}

export function mapSessionResponse(
  response: IAuthSessionResponse,
): IAuthSession {
  return {
    type: response.token_type,
    expiresInSeconds: response.expires_in,
    accessToken: response.access_token,
    refreshToken: response.refresh_token,
  };
}

export function mapRefreshRequest(
  request: IRefreshRequest,
  clientId?: string,
  clientSecret?: string,
): IAuthSessionRequest {
  return {
    refresh_token: request.refreshToken,
    grant_type: 'refresh_token',
    client_id: clientId || '',
    client_secret: clientSecret || '',
  };
}
